import React, { useState } from 'react';

const CaloriesBurnedCalculator = ({ tezina }) => {
  const [weight, setWeight] = useState(tezina);
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [activityCategory, setActivityCategory] = useState('running');
  const [activityType, setActivityType] = useState('6');
  const [caloriesBurned, setCaloriesBurned] = useState(null);

  // MET values for different subcategories of activities
  const activities = {
    running: {
      label: 'Trčanje',
      types: {
        '5': { label_kg: '8 km/h (lagano)', met: 8.3 },
        '6': { label_kg: '9.7 km/h (srednje)', met: 9.8 },
        '7': { label_kg: '11.3 km/h (brzo)', met: 11.0 },
      },
    },
    walking: {
      label: 'Šetanje',
      types: {
        '2': { label_kg: '3.2 km/h (lagano)', met: 2.8 },
        '3': { label_kg: '4.8 km/h (umereno)', met: 3.8 },
        '4': { label_kg: '6.4 km/h (brzo)', met: 5.0 },
      },
    },
    cycling: {
      label: 'Vožnja bicikla',
      types: {
        '10': { label_kg: '16 km/h (lagano)', met: 6.0 },
        '12': { label_kg: '19 km/h (umereno)', met: 8.0 },
        '14': { label_kg: '22.5 km/h (brzo)', met: 10.0 },
      },
    },
    swimming: {
      label: 'Plivanje',
      types: {
        leisure: { label_kg: 'umereno plivanje', met: 7.0 },
        vigorous: { label_kg: 'Intenzivno plivanje', met: 10.0 },
      },
    },
  };

  const handleCalculate = () => {
    // Check for missing inputs
    if (!weight) {
      alert('Molimo unesite težinu.');
      return;
    }
    if (!hours && !minutes) {
      alert('Molimo unesite trajanje aktivnosti.');
      return;
    }

    const met = activities[activityCategory].types[activityType].met;
    const weightInKg = parseFloat(weight);
    const durationInHours = parseFloat(hours) + parseFloat(minutes) / 60; // combine hours and minutes

    // Calories Burned formula
    const calories = met * weightInKg * durationInHours;
    setCaloriesBurned(calories);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md border border-gray-500">
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Kalkulator Potrošenih Kalorija</h1>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Težina (kg)</label>
        <input
          type="number"
          placeholder="Težina (kg)"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        />
      </div>

      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Trajanje aktivnosti:</h3>
        <div className="flex space-x-4">
          <input
            type="number"
            placeholder="Sati"
            value={hours}
            onChange={(e) => setHours(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full"
          />
          <input
            type="number"
            placeholder="Minuti"
            value={minutes}
            onChange={(e) => setMinutes(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full"
          />
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Tip aktivnosti</label>
        <select
          value={activityCategory}
          onChange={(e) => setActivityCategory(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full mb-4"
        >
          {Object.entries(activities).map(([key, value]) => (
            <option key={key} value={key}>
              {value.label}
            </option>
          ))}
        </select>

        {/* Radio buttons for specific activity */}
        <div className="mb-4">
          <h3 className="text-lg font-semibold mb-2">Preciznija aktivnost:</h3>
          {Object.entries(activities[activityCategory].types).map(([key, value]) => (
            <label key={key} className="flex items-center mb-2">
              <input
                type="radio"
                name="activityType"
                value={key}
                checked={activityType === key}
                onChange={(e) => setActivityType(e.target.value)}
                className="mr-2"
              />
              {value.label_kg}
            </label>
          ))}
        </div>
      </div>

      <button
        onClick={handleCalculate}
        className="w-full bg-blue-600 text-white rounded-lg py-3 hover:bg-blue-700 transition duration-300"
      >
        Izračunaj Potrošene Kalorije
      </button>

      {caloriesBurned !== null && (
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-800">
            Potrošene kalorije: {caloriesBurned.toFixed(2)}
          </h2>
        </div>
      )}
    </div>
  );
};

export default CaloriesBurnedCalculator;
